import React from 'react';
import './WhatsAppButton.css';

function WhatsAppButton() {
    const phone = '971508364814';
    const text = encodeURIComponent(
        'Hi CleanSweep, I need waste collection services in Dubai.'
    );

    return (
        <a
            className="wa-float"
            href={`https://wa.me/${phone}?text=${text}`}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Chat with CleanSweep on WhatsApp"
            title="Chat with us on WhatsApp"
        >
            <img
                src="/whatsapp.png"
                alt="WhatsApp"
                className="wa-icon"
            />
        </a>
    );
}

export default WhatsAppButton;
